import $ from "jquery";

export const hashtagWidth = () => {
    $('.material-content__parts-wrapper').each((i, content) => {
        const elemMargin = 20;
        const buttonWidth = 45;
        const parentMaterial = $(content);

        let width = $('.material-content-hashtag-list__inner').width() - buttonWidth;
        let isMoreTagsButtonNeeded = false;

        parentMaterial.find('.material-content-hashtag-list__inner .material-content-hashtag').remove();

        parentMaterial.find('.material-content-hashtag--hidden a').each((i, hiddenHashtagLink) => {
            const hiddenHashtag = $(hiddenHashtagLink);
            const listData = parentMaterial.find('.material-content-hashtag-list__data');
            const elementWidth = (hiddenHashtag.width() + elemMargin);

            const isMain = hiddenHashtag.data('hashtagType') === 'main';

            if (elementWidth < width) {
                listData.append(wrapHashtag(
                    isMain ? 'material-content-hashtag material-content-hashtag--active' : 'material-content-hashtag',
                    hiddenHashtag.html(),
                    hiddenHashtag.attr('href')
                ));
                width -= elementWidth;
            } else {
                isMoreTagsButtonNeeded = true;
            }
        });

        const btn = parentMaterial.find('.material-content-hashtag-list__more-btn');

        if (isMoreTagsButtonNeeded) {
            btn.show();
        } else {
            btn.hide();
        }
    });
};

const wrapHashtag = (wrapperClass, text, link) => {
    return `<div class="${wrapperClass}"><a href="${link}" target="_blank">${text}</a></div>`;
};
